'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Logger = function () {
  function Logger() {
    _classCallCheck(this, Logger);

    this.level = 'warn';
    this.messages = [];
  }

  _createClass(Logger, [{
    key: 'log',
    value: function log() {
      for (var _len = arguments.length, arg = Array(_len), _key = 0; _key < _len; _key++) {
        arg[_key] = arguments[_key];
      }

      var isMessageLogged = this.messages.find(function (message) {
        return JSON.stringify(message) === JSON.stringify.apply(JSON, arg);
      });
      if (isMessageLogged) {
        return;
      }

      // eslint-disable-next-line
      console.warn.apply(null, [].concat(_toConsumableArray(arg.map(function (m) {
        return '%c' + m;
      })), ['color: red; font-size: small']));
      this.messages = [].concat(_toConsumableArray(new Set(this.messages.concat(arg))));
    }
  }]);

  return Logger;
}();

exports.default = Logger;